import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=30c91384&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=30c91384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c91384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c91384')) {
      api.createRecord('30c91384', component.options)
    } else {
      api.reload('30c91384', component.options)
    }
    module.hot.accept("./Privacy.vue?vue&type=template&id=30c91384&scoped=true&", function () {
      api.rerender('30c91384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Privacy.vue"
export default component.exports